import React, { Component } from "react";
import { compose } from "recompose";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Checkbox from "@material-ui/core/Checkbox";
import Typography from "@material-ui/core/Typography";

const styles = (theme) => ({});

class CheckList extends Component {
  handleToggle = (type, value) => () => {
    this.props.handleCloneOptions(type, value);
  };
  render() {
    const { title, optionList, type } = this.props;
    return (
      <React.Fragment>
        <Typography variant="headline" component="h3">
          {title}
        </Typography>
        <List>
          {optionList.map((value) => (
            <ListItem
              key={value.name}
              dense
              button
              onClick={this.handleToggle(type, value)}
            >
              <Checkbox checked={value.isChecked} tabIndex={-1} disableRipple />
              <ListItemText primary={value.name} />
            </ListItem>
          ))}
        </List>
      </React.Fragment>
    );
  }
}

CheckList.propTypes = {
  theme: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  optionList: PropTypes.array.isRequired,
  handleCloneOptions: PropTypes.func.isRequired,
};

export default compose(
  withStyles(styles, {
    name: "CheckList",
    withTheme: true,
  }),
)(CheckList);
